import React from 'react';
import '../less/light-house.less'
import hero_img from '../img/hero_img.svg';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import InfoBlock from '../../../../../../../auxiliary-components/shared/InfoBlock';
import { lightHouseUsageLink, lightHouseUsageLinkDiia } from '../../../../../../../services/urls/urls';
import BusinessOrder from '../../../../../../BusinessOrder';

export default function template() {
    const page = 'light-house';

    const hero_data = {
      title: 'BUSINESS_LIGHT_HOUSE_HERO_TITLE',
      text: 'BUSINESS_LIGHT_HOUSE_HERO_TEXT',
      link: {
        text: "BUSINESS_LIGHT_HOUSE_HERO_BTN",
        onClick: () => this.toggleModal(),
      }
    }

    return (
      <div className="light-house">
        <Hero
          data={hero_data}
          img={hero_img}
          svg
          page={page}
          className="gov-programs"
        />
        <div className="content">
          <div className="light-house__conditions conditions-light-house">
            <div className="container">
              <div className="conditions-light-house__body">
                <h2 className="conditions-light-house__title">{this.l10n('BUSINESS_LIGHT_HOUSE_CONDITIONS_TITLE')}</h2>
                <div className="conditions-light-house__text">{this.l10n('BUSINESS_LIGHT_HOUSE_CONDITIONS_TEXT_01')}</div>
                <div className="conditions-light-house__subtitle">{this.l10n('BUSINESS_LIGHT_HOUSE_CONDITIONS_SUBTITLE')}</div>
                <div className="conditions-light-house__text">{this.l10n('BUSINESS_LIGHT_HOUSE_CONDITIONS_TEXT_02')}</div>
                <InfoBlock 
                  text={'BUSINESS_LIGHT_HOUSE_INFO_TEXT'}
                />
                <a className="conditions-light-house__btn" href={lightHouseUsageLink} target="_blank" rel="noopener noreferrer">{this.l10n('BUSINESS_LIGHT_HOUSE_CONDITIONS_BTN')}</a>
              </div>
            </div>
          </div>
          <div className="usage-service">
            <div className="container">
              <h2 className="usage-service__title">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_TITLE')}</h2>
              <div className="usage-service__body">
                <div className="usage-service__item item-usage-service">
                  <div className="item-usage-service__title">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_01_TITLE')}</div>
                  <div className="item-usage-service__text">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_01_TEXT')}</div>
                  <button onClick={() => this.toggleModal()} className="item-usage-service__btn">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_01_BTN')}</button>
                </div>
                <div className="usage-service__item item-usage-service">
                  <div className="item-usage-service__title">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_02_TITLE')}</div>
                  <div className="item-usage-service__text">
                    {this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_02_TEXT_01')} <a href={lightHouseUsageLinkDiia} target="_blank" rel="noopener noreferrer">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_02_LINK_01')}</a> {this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_02_TEXT_02')} <a href={lightHouseUsageLink} target="_blank" rel="noopener noreferrer">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_02_LINK_02')}</a>
                  </div>
                </div>
                <div className="usage-service__item item-usage-service">
                  <div className="item-usage-service__title">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_03_TITLE')}</div>
                  <div className="item-usage-service__text">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_03_TEXT')}</div>
                </div>
                <div className="usage-service__item item-usage-service">
                  <div className="item-usage-service__title">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_04_TITLE')}</div>
                  <div className="item-usage-service__text">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_ITEM_04_TEXT')}</div>
                </div>
              </div>
              <div className="usage-service__text">{this.l10n('BUSINESS_LIGHT_HOUSE_USAGE_SERVICE_TEXT')}</div>
            </div>
          </div>
        </div>
        {this.state.showModal && <BusinessOrder attribute="light-house" closeModal={() => this.toggleModal()} />}
      </div>
    );
}
